import Image from 'app/Components/Shared/Image/image';
import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {doCallBackLite, changeHandler, validateHandler, clearAll} from './CallBackLiteSlice';
import TextInput from '../TextInput/TextInput';
import BtnSubmit from '../Buttons/BtnSubmit';
import BtnWhite from '../Buttons/BtnWhite';
import Lottie from 'react-lottie';
import {getRecaptchaToken} from '../../../utilities/recaptcha/recaptcha';
import CheckedAnimation from '../../../animations/approved-checked-outline.json';
import {isMobile} from 'react-device-detect';
import ThemedLottie from '../ThemedLottie/ThemedLottie';
import { ThemeColorEnum } from '../../../utilities/theme/ThemeColorEnum';

const callBackLite = (props) => {
  useEffect(() => {
    props.clearAll();
    async function doCallBack() {
        props.doCallBackLite({idNumber: props.IdNumber, phoneNumber: props.form.phone, subjectCode: props.SubjectCode});
    }
    if (props.form.valid !== '') {
      if (props.form.valid) {
        doCallBack();
      }
    }
  }, [props.form.valid]);

  let callBackError = (
    <div>
      {isMobile ? (
        <BtnWhite
          onclick={() => (window.location = `tel:${window.Config.technicalSupportPhone}`)}
          text={
            <>
              <Image className='icon-phone' src={require('./images/icons-phone.svg')} alt='טלפון' /> דברו איתנו ב-{window.Config.technicalSupportPhone}
            </>
          }></BtnWhite>
      ) : (
        <div>
          <Image className='icon-phone' src={require('./images/icons-phone.svg')} alt='טלפון' />
          <span> דברו איתנו ב-{window.Config.technicalSupportPhone}</span>
        </div>
      )}
    </div>
  );

  return (
    <div className='callback-lite'>
      {props.success ? (
        <div>
          <p className='call-success-title'>תודה, נשתמע בקרוב</p>
          {/* <Lottie options={{animationData: CheckedAnimation, loop: false}} width={127} height={127} /> */}
          <ThemedLottie animationData={CheckedAnimation} color={ThemeColorEnum.PRIMARY} width={127} height={127} loop={false} />
          <BtnSubmit onclick={() => props.close()} text='סיום'></BtnSubmit>
        </div>
      ) : (
        <div>
          <p className='msg-title'>{props.title}</p>
          <Image className='error-img' src={require('./images/icons-error.svg')} alt='שגיא' />
          {props.isCallBackError ? (
            callBackError
          ) : (
            <div>
              <p className='sub-title'>{props.text}</p>
              <p className='sub-title-text'>השאירו טלפון ונחזור אליכם תוך יום עסקים אחד כדי לטפל בזה:</p>
              <TextInput
                name='phone'
                type='tel'
                autoComplete='off'
                placeholder='מספר טלפון'
                maxLength='10'
                value={props.form.phone}
                error={props.form.errors.phone}
                onChange={(e) => props.changeHandler({target: e.target, form: props.form})}
              />
              <BtnSubmit onclick={() => props.validateHandler(props.form)} text='תחזרו אלי'></BtnSubmit>
              {props.isCallbackExist ? <p className='callback-exist-msg'>טלפון זה כבר נרשם לשיחה חוזרת</p> : null}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    form: state.CallBackLite.form,
    isCallBackError: state.CallBackLite.isCallBackError,
    success: state.CallBackLite.success,
    isCallbackExist: state.CallBackLite.isCallbackExist,
  };
};

const mapDispatchToProps = {doCallBackLite, changeHandler, validateHandler, clearAll};

export default connect(mapStateToProps, mapDispatchToProps)(callBackLite);
